import { SVGProps, Ref, forwardRef } from 'react';

export const FolderFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M1 5.667C1 2.167 2.167 1 5.667 1h2L8.2 2.333h2.133c3.079 0 4.352.903 4.614 3.501a5 5 0 0 0-.305-.087c-.711-.182-1.535-.247-2.438-.247H3.796c-.903 0-1.727.065-2.438.247q-.18.045-.358.105z"
                fill="currentColor"
            />
            <path
                d="M15.765 10.899c-.724 2.999-1.97 4.1-5.365 4.1H5.6C2.204 15 .96 13.899.235 10.9c-.725-3 .165-4 3.561-4h8.408c3.396 0 4.286 1 3.561 4"
                fill="currentColor"
            />
        </g>
    </svg>
));
FolderFilledSize16Glyph.displayName = 'FolderFilledSize16Glyph';
